export default {
  _IS: [
    {
      label: "是",
      value: true,
    },
    {
      label: "否",
      value: false,
    },
  ],
  _industryList: [
    {label: '物联网', value: '物联网',},
    {label: '5G', value: '5G',},
    {label: '人工智能', value: '人工智能',},
    {label: '半导体及集成电路', value: '半导体及集成电路',},
    {label: '数字安防', value: '数字安防',},
    {label: '智能制造', value: '智能制造',},
    {label: '通信设备', value: '通信设备',},
    {label: '节能环保', value: '节能环保',},
    {label: '新能源', value: '新能源',},
    {label: '3D打印（增材制造）', value: '3D打印（增材制造）',},
    {label: '机器人', value: '机器人',},
    {label: '超高清视频', value: '超高清视频',},
    {label: '生物医药与健康', value: '生物医药与健康',},
    {label: '集成电路', value: '集成电路',},
    {label: '区块链', value: '区块链',},
    {label: '量子信息', value: '量子信息',}
  ],
  _typeList:[
    {label: '科技成果', value: '科技成果',},
    {label: '专利技术', value: '专利技术',},
    // {label: '解决方案', value: '解决方案',},
    // {label: '高校院所自持专利资产', value: '高校院所自持专利资产',}
  ],
  _modeList:[
    {label: '全部', value: '',},
    {label: '技术入股', value: '技术入股',},
    {label: '委托开发', value: '委托开发',},
    {label: '产业化落地', value: '产业化落地',},
    {label: '技术咨询', value: '技术咨询',},
    {label: '技术改造', value: '技术改造',},
    {label: '专利转让', value: '专利转让',},
    {label: '专利许可', value: '专利许可',},
    {label: '其他', value: '其他',},
  ],
  _modeFormList:[
    {label: '技术入股', value: '技术入股',},
    {label: '委托开发', value: '委托开发',},
    {label: '产业化落地', value: '产业化落地',},
    {label: '技术咨询', value: '技术咨询',},
    {label: '技术改造', value: '技术改造',},
    {label: '专利转让', value: '专利转让',},
    {label: '专利许可', value: '专利许可',},
    {label: '其他', value: '其他',},
  ],
  _priceList:[
      {label: '具体面议', value: '具体面议',},
      {label: '0-10万', value: '0-10万',},
      {label: '10-20万', value: '10-20万',},
      {label: '20-30万', value: '20-30万',},
      {label: '30-40万', value: '30-40万',},
      {label: '40-50万', value: '40-50万',},
      {label: '50-60万', value: '50-60万',},
      {label: '60-70万', value: '60-70万',},
      {label: '70-80万', value: '70-80万',},
      {label: '80-90万', value: '80-90万',},
      {label: '90-100万', value: '90-100万',},
      {label: '100万以上', value: '100万以上',},
  ],
  _resourceType:[
    {value:"区域产业与科技政策",label:'区域产业与科技政策'},
    {value:'科研团队',label:'科研团队'},
    {value:'科技合作平台',label:'科技合作平台'},
    {value:'科技政策',label:'科技政策'},
    {value:'区域服务典型案例',label:'区域服务典型案例'},
  ],
  _levelList:[
    {value:"国家",label:'国家'},
    {value:'部委',label:'部委'},
    {value:'省',label:'省'},
    {value:'市',label:'市'},
    {value:'区',label:'区'},
    {value:'高新区',label:'高新区'},
    {value:'经开区',label:'经开区'},
  ],
  _techTypeList:[
    {value:"法人性质异地科研机构",label:'法人性质异地科研机构'},
    {value:'非法人性质产学研合作平台',label:'非法人性质产学研合作平台'},
  ]
};
